import React from 'react';

import { useTranslation } from 'i18n/hooks';

import { buildItemsListingRoute } from 'modules/catalog/utils';

import { Link } from 'ui/components/Link';
import { MarketplaceAPI } from 'revibe-api';

type Props = {
  sex?: string;
  category: MarketplaceAPI.Category | null;
};

export const ShopBreadcrumb = ({ sex = 'all', category }: Props) => {
  const { tu } = useTranslation();

  return (
    <div className="grid grid-cols-3 items-stretch gap-[1px] overflow-hidden border-b border-black md:flex">
      <Link
        hasDecoration={false}
        to={buildItemsListingRoute()}
        className="font-formula -mb-1 -ml-1 box-border overflow-hidden text-ellipsis whitespace-nowrap border-r border-black px-4 py-1 pl-5 uppercase tracking-wider text-black hover:bg-black hover:text-white lg:border-r-0"
      >
        {tu('all-items', 'shop.categories')}
      </Link>
      {sex && (
        <Link
          className="font-formula -mb-1 -ml-1 box-border overflow-hidden text-ellipsis whitespace-nowrap border-r border-black px-4 py-1 uppercase tracking-wider text-black hover:bg-black hover:text-white lg:border-r-0"
          hasDecoration={false}
          to={buildItemsListingRoute(sex)}
        >
          {tu(sex, 'common')}
        </Link>
      )}
      {category !== null && (
        <Link
          hasDecoration={false}
          className="font-formula lg: -mb-1 -ml-1 box-border overflow-hidden text-ellipsis whitespace-nowrap border-r px-4 py-1 uppercase tracking-wider text-black hover:bg-black hover:text-white lg:border-r-0 lg:border-black"
          to={buildItemsListingRoute(sex, category.slug)}
        >
          {category.name}
        </Link>
      )}
    </div>
  );
};
